import { gql } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';
import { JourneyResourceData } from '../Launchpad.types';

export const getLiveOrDraftByParentId = gql`
  fragment JourneyData on Workflow {
    id
    name
    workflowType
    isArchived
  }

  query getJourneyById($id: Long!) {
    getLiveOrDraftByParentId(parentJourneyId: $id) {
      childLive {
        ...JourneyData
      }
      
      childDraft {
        ...JourneyData
      }
    }
  }
`;

type JourneyResourceDataResponse = {
  getLiveOrDraftByParentId?: {
    childLive?: JourneyResourceData;
    childDraft?: JourneyResourceData;
  };
};

export const useGetJourneyResourceData = (id: number) => {
  const { data, isLoading, error } = useGraphql<JourneyResourceDataResponse>(
    getLiveOrDraftByParentId,
    {
      variables: { id },
    },
  );

  return {
    resource:
      data?.getLiveOrDraftByParentId?.childLive || data?.getLiveOrDraftByParentId?.childDraft,
    isLoading,
    hasError: !!error,
  };
};
